import { render, staticRenderFns } from "./KeyValueForm.vue?vue&type=template&id=546f0a39&scoped=true"
import script from "./KeyValueForm.vue?vue&type=script&lang=js"
export * from "./KeyValueForm.vue?vue&type=script&lang=js"
import style0 from "./KeyValueForm.vue?vue&type=style&index=0&id=546f0a39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546f0a39",
  null
  
)

export default component.exports